/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EvidenceType,
  EvidenceType$inboundSchema,
  EvidenceType$outboundSchema,
} from "./evidencetype.js";

export type UpdateEvidence = {
  evidenceType?: EvidenceType | undefined;
  /**
   * If updating text evidence, the new text to associate with the dispute.
   */
  text?: string | undefined;
};

/** @internal */
export const UpdateEvidence$inboundSchema: z.ZodType<
  UpdateEvidence,
  z.ZodTypeDef,
  unknown
> = z.object({
  evidenceType: EvidenceType$inboundSchema.optional(),
  text: z.string().optional(),
});
/** @internal */
export type UpdateEvidence$Outbound = {
  evidenceType?: string | undefined;
  text?: string | undefined;
};

/** @internal */
export const UpdateEvidence$outboundSchema: z.ZodType<
  UpdateEvidence$Outbound,
  z.ZodTypeDef,
  UpdateEvidence
> = z.object({
  evidenceType: EvidenceType$outboundSchema.optional(),
  text: z.string().optional(),
});

export function updateEvidenceToJSON(updateEvidence: UpdateEvidence): string {
  return JSON.stringify(UpdateEvidence$outboundSchema.parse(updateEvidence));
}
export function updateEvidenceFromJSON(
  jsonString: string,
): SafeParseResult<UpdateEvidence, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateEvidence$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateEvidence' from JSON`,
  );
}
